'use client';

import { useFlags } from 'launchdarkly-react-client-sdk';

export type FeatureFlags = {
  shopifyPluginEnabled: boolean;
};

export const useFeatureFlags = () => {
  return useFlags<FeatureFlags>();
};
